module.exports = __webpack_public_path__ + "static/media/ATMA-SPHERE MA-2 TUBE AMPLIFIER.62b225d5.png";